import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

export interface useEspelhoVendasInterface {
  codigoSap: string;
  nomeBloco: string;
}

export function useEspelhoVendas(
  props: useEspelhoVendasInterface & QueryGlobalInterface
) {
  const fetchData = async () => {
    const ESPELHO_VENDAS = `${backofficeEnviroment}/common/oportunidades-lead/espelho-vendas/v1/${props.codigoSap}/${props?.nomeBloco}`;
    const response = await instance.get(ESPELHO_VENDAS);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: false,
    cacheTime: 0,
    onError: (error: any) => {
      toast?.error(
        `Erro ao buscar espelho de vendas. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
